export default {
    AppBaseName: process.env.VUE_APP_BASE_NAME,
    AppBaseUrl: process.env.VUE_APP_APP_BASE_URL + process.env.VUE_APP_BASE_NAME, 
    ApiBaseName: process.env.VUE_APP_API_BASE_NAME,
    ApiBaseUrl: process.env.VUE_APP_API_BASE_URL + process.env.VUE_APP_API_BASE_NAME
};